<mat-form-field class="zef-input-small" [class.zef-input-space]="space">
  <mat-icon [color]="color" matPrefix>time</mat-icon>

  <input matInput [placeholder]="placeholder" (blur)="updateTime()" />

  <button *ngIf="clearable" matSuffix mat-icon-button (click)="clearTime()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
